import React, { createContext, useContext, useState, useEffect } from "react";
import { useAuth } from './AuthProvider';
import axios from 'axios';

const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

const api = axios.create({
    baseURL: apiBaseUrl,
});

const CartContext = createContext();

export const CartProvider = ({ children }) => {
    const { userId, token } = useAuth();
    const [cartItems, setCartItems] = useState([]);

    useEffect(() => {
        if (!userId) {
            setCartItems([]);
        }
    }, [userId]);

    useEffect(() => {

        let loginUserId = Number(userId);
        if (loginUserId) {
            const fetchCartDetails = async () => {
                try {
                    const response = await api.get(`/users/GetCartItems?userId=${loginUserId}`,
                        {
                            headers: {
                                Authorization: `Bearer ${token}`,
                            },
                        }
                    );
                    console.log(response);
                    setCartItems(response.data);
                } catch (error) {
                    console.error('Error fetching data:', error);
                }
            };

            fetchCartDetails();
        }
    }, [userId, token]);

    const addToCartContext = (item) => {
        setCartItems((prev) => [...prev, item]);
    };

    const removeFromCartContext = (id) => {
        setCartItems((prev) => prev.filter((item) => item.productId !== id));
    };

    const clearCart = () => {
        setCartItems([]);
    };

    const cartCount = cartItems.length;

    return (
        <CartContext.Provider value={{ cartItems, addToCartContext, removeFromCartContext, clearCart, cartCount }}>
            {children}
        </CartContext.Provider>
    );
};

export const useCart = () => useContext(CartContext);